import React, { useState, useEffect } from 'react';
import SearchBar from '../components/SearchBar';
import { fetchStockData, fetchCurrencyRates } from '../services/api';  // Only keep the necessary imports

const Home = () => {
  const [stockData, setStockData] = useState(null);
  const [currencyRates, setCurrencyRates] = useState({});
  const [selectedCurrency, setSelectedCurrency] = useState('USD');
  const [error, setError] = useState('');

  // Fetch currency rates
  useEffect(() => {
    const getCurrencyRates = async () => {
      try {
        const rates = await fetchCurrencyRates();
        setCurrencyRates(rates);
      } catch (err) {
        console.error("Error fetching currency rates:", err);
      }
    };
    getCurrencyRates();
  }, []);

  const handleSearch = async (symbol) => {
    try {
      const stockSymbol = symbol.trim().toUpperCase(); // Ensure uppercase
      console.log(`Searching for stock symbol: ${stockSymbol}`);

      const stock = await fetchStockData(stockSymbol);
      console.log('Fetched Stock Data:', stock);

      if (stock) {
        setStockData(stock);
        setError('');
      } else {
        setError(`No data found for the stock symbol "${stockSymbol}". Please try another ticker.`);
      }
    } catch (err) {
      console.error('An error occurred while fetching stock data:', err);
      setError('An error occurred while fetching stock data. Please try again later.');
    }
  };

  // Function to convert stock values to selected currency
  const convertToCurrency = (value) => {
    if (currencyRates[selectedCurrency]) {
      const conversionRate = currencyRates[selectedCurrency];
      return (value * conversionRate).toFixed(2);  // Convert to selected currency
    }
    return value;  // If no currency rates available, return the original value
  };

  return (
    <div className="home">
      <h1>Stock Search</h1>
      <SearchBar onSearch={handleSearch} />
      {error && <p className="error">{error}</p>}
      {stockData && (
        <div className="stock-details">
          <h2>Stock Details</h2>
          <p><strong>Symbol:</strong> {stockData.symbol || 'N/A'}</p>
          <p><strong>Price:</strong> {convertToCurrency(stockData.price) || 'N/A'} {selectedCurrency}</p>
          <p><strong>Open:</strong> {convertToCurrency(stockData.open) || 'N/A'}</p>
          <p><strong>High:</strong> {convertToCurrency(stockData.high) || 'N/A'}</p>
          <p><strong>Low:</strong> {convertToCurrency(stockData.low) || 'N/A'}</p>
          <p><strong>Currency:</strong> {stockData.currency || 'N/A'}</p>
        </div>
      )}

      {/* Render currency selection */}
      <div>
        <label>Select Currency: </label>
        <select
          value={selectedCurrency}
          onChange={(e) => setSelectedCurrency(e.target.value)}
        >
          {Object.keys(currencyRates).map((currency) => (
            <option key={currency} value={currency}>
              {currency}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default Home;
